import BehaviorConfig from '@/models/app-config/behavior/behavior'
import {
  defaultFormParts,
  fitowaFormParts,
  ledianFormParts,
  mycolorFormParts,
  SignUpFormParts,
  vilbFormParts,
} from './form-parts'

export function createSignUpFormParts(behavior: BehaviorConfig): SignUpFormParts {
  if (behavior.isVilb) return vilbFormParts(behavior)

  if (behavior.isFitowa) return fitowaFormParts(behavior)

  if (behavior.isMyColor) return mycolorFormParts(behavior)

  if (behavior.isLedian) return ledianFormParts(behavior)

  return defaultFormParts()(behavior)
}
